import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import StandardCreateUpdate from "./create-update";
import { StandardItem } from "../../../models/types/standard";
import standardSvc from "../../../services/api/standard";
import Loading from "../../../components/loading/loading";

export default function StandardCreateUpdatePage() {
    const { id } = useParams<{ id?: string }>();

    const isCreate = !id;
    const [data, setData] = useState<StandardItem | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (id) {
            setLoading(true);
            standardSvc.getStandardById(id).then((res) => {
                setData(res.content);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id]);
    return (
        <div className="page-wrapper h-full">
            {loading ? <Loading /> : <StandardCreateUpdate isCreate={isCreate} data={data} />}
        </div>
    );
}